var map = {
	"./ColorMode": "241f",
	"./ColorMode.js": "241f",
	"./CoverType": "8f9b",
	"./CoverType.js": "8f9b",
	"./DocumentProductionStatus": "9f34",
	"./DocumentProductionStatus.js": "9f34",
	"./DocumentValidationStatus": "71e3",
	"./DocumentValidationStatus.js": "71e3",
	"./EmailType": "956a",
	"./EmailType.js": "956a",
	"./EnumBaseMixin": "087f",
	"./EnumBaseMixin.js": "087f",
	"./FileUploadStatus": "0b63",
	"./FileUploadStatus.js": "0b63",
	"./FoldType": "ef90",
	"./FoldType.js": "ef90",
	"./FrankingType": "d992",
	"./FrankingType.js": "d992",
	"./LetterType": "e1d3f",
	"./LetterType.js": "e1d3f",
	"./PaperType": "6b37",
	"./PaperType.js": "6b37",
	"./PrintMode": "4d06",
	"./PrintMode.js": "4d06",
	"./Salutation": "090b",
	"./Salutation.js": "090b",
	"./SplitType": "0c16",
	"./SplitType.js": "0c16",
	"./orderStatus": "1f3c",
	"./orderStatus.js": "1f3c",
	"./validationStatus": "e5de",
	"./validationStatus.js": "e5de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "79db";